var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.4755 5.21747C0.871371 5.56803 0.5 6.21066 0.5 6.9055V20.5449C0.5 21.6247 1.38144 22.5 2.46875 22.5H19.5312C20.6186 22.5 21.5 21.6247 21.5 20.5449V6.9055C21.5 6.21066 21.1286 5.56803 20.5245 5.21747L11.9933 0.267053C11.3796 -0.0890178 10.6204 -0.0890175 10.0067 0.267053L1.4755 5.21747ZM9.5 9C9.08579 9 8.75 9.33579 8.75 9.75V12.75C8.75 13.1642 9.08579 13.5 9.5 13.5H12.5C12.9142 13.5 13.25 13.1642 13.25 12.75V9.75C13.25 9.33579 12.9142 9 12.5 9H9.5ZM5.75 15C5.33579 15 5 15.3358 5 15.75V18.75C5 19.1642 5.33579 19.5 5.75 19.5H8.75C9.16421 19.5 9.5 19.1642 9.5 18.75V15.75C9.5 15.3358 9.16421 15 8.75 15H5.75ZM12.5 15.75C12.5 15.3358 12.8358 15 13.25 15H16.25C16.6642 15 17 15.3358 17 15.75V18.75C17 19.1642 16.6642 19.5 16.25 19.5H13.25C12.8358 19.5 12.5 19.1642 12.5 18.75V15.75Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseActive);
export default __webpack_public_path__ + "static/media/house-active.04e2ad758dc286475f533c31f018a699.svg";
export { ForwardRef as ReactComponent };